var _rect, _path, _rect2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAud = function SvgAud(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107623)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2H16V14H0V2Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5513_107623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 9,
    height: 7
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 9,
    height: 7,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5513_107623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.00208 8.49991L0.9784 9.36852L9.045 2.94438L10.0897 1.65361L7.97182 1.3633L4.68165 4.13164L2.0334 5.99686L-1.00208 8.49991Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.730957 9.10847L0.278004 9.61253L9.71451 1.53368H8.29782L-0.730957 9.10847Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0022 8.49991L8.02172 9.36852L-0.0448761 2.94438L-1.08953 1.65361L1.0283 1.3633L4.31847 4.13164L6.96673 5.99686L10.0022 8.49991Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93457 8.93667L8.92561 9.44073L4.90745 5.98176L3.71615 5.59529L-1.1901 1.65803H0.226597L5.13009 5.50184L6.43256 5.96525L9.93457 8.93667Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-1_5513_107623",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 1,
    width: 11,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: 1,
    width: 11,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99225 2H3.99225V5H0V6H3.99225V9H4.99225V6H9V5H4.99225V2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99225 2H3.99225V5H0V6H3.99225V9H4.99225V6H9V5H4.99225V2Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99225 2V1.25H3.24225V2H3.99225ZM4.99225 2H5.74225V1.25H4.99225V2ZM3.99225 5V5.75H4.74225V5H3.99225ZM0 5V4.25H-0.75V5H0ZM0 6H-0.75V6.75H0V6ZM3.99225 6H4.74225V5.25H3.99225V6ZM3.99225 9H3.24225V9.75H3.99225V9ZM4.99225 9V9.75H5.74225V9H4.99225ZM4.99225 6V5.25H4.24225V6H4.99225ZM9 6V6.75H9.75V6H9ZM9 5H9.75V4.25H9V5ZM4.99225 5H4.24225V5.75H4.99225V5ZM3.99225 2.75H4.99225V1.25H3.99225V2.75ZM4.74225 5V2H3.24225V5H4.74225ZM0 5.75H3.99225V4.25H0V5.75ZM0.75 6V5H-0.75V6H0.75ZM3.99225 5.25H0V6.75H3.99225V5.25ZM4.74225 9V6H3.24225V9H4.74225ZM4.99225 8.25H3.99225V9.75H4.99225V8.25ZM4.24225 6V9H5.74225V6H4.24225ZM9 5.25H4.99225V6.75H9V5.25ZM8.25 5V6H9.75V5H8.25ZM4.99225 5.75H9V4.25H4.99225V5.75ZM4.24225 2V5H5.74225V2H4.24225Z",
    fill: "#F7FCFF",
    mask: "url(#path-8-outside-1_5513_107623)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5513_107623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40804 11.8342L3.81761 12.3799L3.87608 11.5781L3.08136 11.4567L3.7447 11.0024L3.34412 10.3054L4.11283 10.5408L4.40804 9.79305L4.70326 10.5408L5.47196 10.3054L5.07138 11.0024L5.73472 11.4567L4.94 11.5781L4.99847 12.3799L4.40804 11.8342Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.776 8.06899L10.3824 8.43275L10.4213 7.89821L9.89152 7.81726L10.3337 7.51446L10.0667 7.04976L10.5792 7.20671L10.776 6.70819L10.9728 7.20671L11.4853 7.04976L11.2182 7.51446L11.6604 7.81726L11.1306 7.89821L11.1696 8.43275L10.776 8.06899Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7147 4.37667L11.3211 4.74043L11.3601 4.20588L10.8302 4.12494L11.2725 3.82213L11.0054 3.35744L11.5179 3.51439L11.7147 3.01587L11.9115 3.51439L12.424 3.35744L12.1569 3.82213L12.5991 4.12494L12.0693 4.20588L12.1083 4.74043L11.7147 4.37667Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0614 6.22283L13.6678 6.58659L13.7067 6.05204L13.1769 5.9711L13.6191 5.66829L13.3521 5.2036L13.8646 5.36055L14.0614 4.86203L14.2582 5.36055L14.7707 5.2036L14.5036 5.66829L14.9458 5.9711L14.416 6.05204L14.455 6.58659L14.0614 6.22283Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1841 11.5305L11.7904 11.8943L11.8294 11.3597L11.2996 11.2788L11.7418 10.976L11.4748 10.5113L11.9872 10.6682L12.1841 10.1697L12.3809 10.6682L12.8933 10.5113L12.6263 10.976L13.0685 11.2788L12.5387 11.3597L12.5777 11.8943L12.1841 11.5305Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8266 8.64789L13.4267 8.85814L13.5031 8.41282L13.1795 8.09743L13.6267 8.03246L13.8266 7.62729L14.0266 8.03246L14.4737 8.09743L14.1502 8.41282L14.2266 8.85814L13.8266 8.64789Z",
    fill: "#F7FCFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5513_107623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "AUD.21d05b3276bd939932505dfd8c2b2daa.svg";